<template>
	<public-form-layout :title="title">

		<document :src="src" height="40vh" :param="param" />
		
	</public-form-layout>
</template>


<script>
	import { PublicFormLayout } from '@/layouts';
	import { Document } from '@/components/documents';


	export default {
		name: 'public-document',
		components: {
			Document,
			PublicFormLayout
		},
		props: {
			title: {
				type: String,
				required: true,
				default: null
			},
			src: {
				type: Object,
				required: true,
				default: null
			},
			param: {
				type: String,
				required: false,
				default: null
			}
		}
	};
</script>


<style lang="scss">
@import '~@/assets/styles/references';
</style>